import { patientActions, diaryActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {

    [patientActions.loadSuccess]: (state, action) => {
        var patients = {};

        Object.values(action.payload.entities.patients).forEach(x => {
            patients[x.id] = {
                id: x.id,
                newItemVisible: false,
                isIssue: false
            };
        });
        state = { ...state, ...patients };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        return { ...state, ...action.payload.ui.diary };
    },
    [patientActions.closeSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [diaryActions.showDiary]: (state, action) => {
        state[action.payload].newItemVisible = true;
    },
    [diaryActions.hideDiary]: (state, action) => {
        state[action.payload].newItemVisible = false;
        state[action.payload].isIssue = false;
    },
    [diaryActions.saveDiarySuccess]: (state, action) => {
        state[action.payload].newItemVisible = false;
        state[action.payload].isIssue = false;
    },
    [diaryActions.toggleIssue]: (state, action) => {
        state[action.payload].isIssue = !state[action.payload].isIssue;
    },


})


